/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grading_TitleInputs */

const da_grading_title = /** @type {(inputs: Grading_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rettelse`)
};

/** @type {(inputs: Grading_TitleInputs) => LocalizedString} */
const en_grading_title = da_grading_title;

/**

* @param {Grading_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const grading_title = /** @type {((inputs?: Grading_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grading_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_grading_title(inputs)
	return /** @type {LocalizedString} */ ("Rettelse")
});